import DinoStepper from "../../components/Stepper";
import {Grid, Stack} from "@mui/material";
import Selected from "./Selected";
import SelectCategory from "./SelectCategory";
import SelectService from "./SelectService";
import SelectPrice from "./SelectPrice";
import SelectDate from "./SelectDate";
import FillData from "./FillData";
import {useContext} from "react";
import Typography from "@mui/material/Typography";
import ReservationContext from "../../context/ReservationContext";
import Loading from "../Loading";


const ReserveBase = () => {
    const {loading, activeStep} = useContext(ReservationContext)

    const stepMap = [
        <SelectCategory/>,
        <SelectService/>,
        <SelectPrice/>,
        <SelectDate/>,
        <FillData/>,
    ]

    const textMap = [
        {heading: 'Szolgáltatási kategóra', text: 'Kérjük válassz az alábbi kategóriák közül'},
        {heading: 'Szolgáltatás', text: 'Kérjük válassz az alábbi szolgáltatások közül'},
        {heading: 'Kollégáink', text: 'Kérjük válassz kollégáink közül'},
        {heading: 'Időpont', text: 'Kérjük válassz időpontot'},
        {heading: 'Személyes adatok', text: 'Kérjük add meg adatokat'},
    ]

    return <>
        <Stack>
            <Typography variant="subtutle1" style={{color: '#6F8E9A', fontWeight: '700'}} gutterBottom>{textMap[activeStep].text}</Typography>
        </Stack>
        <DinoStepper/>

        <Grid container spacing={6}>
            <Grid item xs={12} md={7}>
                {stepMap[activeStep]}
            </Grid>
            <Grid item xs={12} md={5}>
                <Selected />
            </Grid>
        </Grid>

        <Loading isLoading={loading}/>
    </>
}

export default ReserveBase